"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = __importDefault(require("@app/store"));
const permissions_pool_1 = require("@app/const/permissions-pool");
const is_defined_1 = require("./is-defined");
function canRead(permission, currentPermissionsOverride = null, workspaceIdOverride) {
    let currentWsPermissions = currentPermissionsOverride || [];
    if (!currentPermissionsOverride) {
        const storeState = store_1.default.getState();
        const { me, workspaceId } = storeState;
        const resolvedWorkspaceId = workspaceIdOverride || workspaceId;
        const meAclWorkspaces = me?.acl?.workspaces;
        const aclWorkspaces = meAclWorkspaces && Object.keys(meAclWorkspaces);
        currentWsPermissions =
            aclWorkspaces?.length && (0, is_defined_1.isValue)(resolvedWorkspaceId)
                ? meAclWorkspaces?.[resolvedWorkspaceId]
                : [];
    }
    if (typeof permission === 'string') {
        return (currentWsPermissions?.includes(`${permission}_read`) ||
            currentWsPermissions?.includes(`${permission}_write`));
    }
    else {
        return currentWsPermissions?.some((wsPermission) => {
            // @ts-expect-error Argument of type '(permissionItem: string) => boolean' is not assignable to parameter of type '(value: unknown, index: number, array: unknown[]) => unknown'.
            return Object.values(permission).some((permissionItem) => {
                return (wsPermission === `${permissionItem}_read` ||
                    wsPermission === `${permissionItem}_write`);
            });
        });
    }
}
function canReadOneOf(perms) {
    const storeState = store_1.default.getState();
    const { me, workspaceId } = storeState;
    const meAclWorkspaces = me?.acl?.workspaces;
    const aclWorkspaces = meAclWorkspaces && Object.keys(meAclWorkspaces);
    const currentWsPermissions = aclWorkspaces?.length && (0, is_defined_1.isValue)(workspaceId)
        ? meAclWorkspaces?.[workspaceId]
        : [];
    return perms.some((p) => canRead(p, currentWsPermissions));
}
function canWrite(permission, currentPermissionsOverride = null) {
    let currentWsPermissions = currentPermissionsOverride || [];
    if (!currentPermissionsOverride) {
        const storeState = store_1.default.getState();
        const { me, workspaceId } = storeState;
        const meAclWorkspaces = me?.acl?.workspaces;
        const aclWorkspaces = meAclWorkspaces && Object.keys(meAclWorkspaces);
        currentWsPermissions =
            aclWorkspaces?.length && (0, is_defined_1.isValue)(workspaceId)
                ? meAclWorkspaces?.[workspaceId]
                : [];
    }
    if (typeof permission === 'string') {
        return currentWsPermissions?.includes(`${permission}_write`);
    }
    else {
        // @ts-expect-error Parameter 'wsPermission' implicitly has an 'any' type, but a better type may be inferred from usage.
        return currentWsPermissions?.includes((wsPermission) => {
            return Object.values(permissions_pool_1.PERMISSIONS[permission]).some(
            // @ts-expect-error Argument of type '(permissionItem: string) => boolean' is not assignable to parameter of type '(value: unknown, index: number, array: unknown[]) => unknown'.
            (permissionItem) => wsPermission === `${permissionItem}_write`);
        });
    }
}
function canWriteOneOf(perms) {
    const storeState = store_1.default.getState();
    const { me, workspaceId } = storeState;
    const meAclWorkspaces = me?.acl?.workspaces;
    const aclWorkspaces = meAclWorkspaces && Object.keys(meAclWorkspaces);
    const currentWsPermissions = aclWorkspaces?.length && (0, is_defined_1.isValue)(workspaceId)
        ? meAclWorkspaces?.[workspaceId]
        : [];
    return perms.some((p) => canWrite(p, currentWsPermissions));
}
exports.default = {
    canRead,
    canReadOneOf,
    canWrite,
    canWriteOneOf,
};
